// Threshold for determining when the user has reached the end of the menu
export const SCROLL_THRESHOLD = 5;
